import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { selectGroupedProductionPlans } from 'workspace/selectors'
import PlanTableRow from './PlanTableRow'

const PlanTable = ({ plans, intl }) => {
  return (
    <div className='timeline-group__extra'>
      <table className='table'>
        <thead>
          <tr>
            <th>{intl.formatMessage({ id: 'workspace.form.priority' })}</th>
            <th>{intl.formatMessage({ id: 'workspace.form.product' })}</th>
            <th>{intl.formatMessage({ id: 'workspace.planTable.operation' })}</th>
            <th>{intl.formatMessage({ id: 'workspace.form.duration' })}</th>
            <th>{intl.formatMessage({ id: 'workspace.form.quantity' })}</th>
            <th>{intl.formatMessage({ id: 'workspace.planTable.realized' })}</th>
            <th>{intl.formatMessage({ id: 'workspace.planTable.bookedBy' })}</th>
            <th>{intl.formatMessage({ id: 'workspace.form.remarks' })}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {plans.map(plan => (
            <PlanTableRow
              key={`${plan.operationGroupUuid}-${plan.productGroupUuid}`}
              id={plan.id}
              scheduleId={plan.scheduleId}
              priority={plan.priority}
              productId={plan.productId}
              bookerId={plan.bookerId}
              calculatedDuration={plan.calculatedDuration}
              productOperation={plan.productOperation}
              piecesQuantity={plan.piecesQuantity}
              realizedQuantity={plan.realizedQuantity}
              remarks={plan.remarks}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    plans: selectGroupedProductionPlans(state)
  }
}

export default compose(
  connect(mapStateToProps),
  injectIntl
)(PlanTable)
